export default __webpack_public_path__ + "static/marketing-icon-7bfd2e12ac8276d65b8a1deb172d4b3f.svg";